import type { TExportEventType } from "constants/index";

export const SCOPE_LIST_EXPORT_EXCLUDED_COLUMNS = ["add"];

export function designScopeLinkedScopeExportEventType(
  format: "CSV" | "EXCEL" | "PDF"
): TExportEventType {
  if (format === "EXCEL") return "DESIGN_SCOPE_MILESTONE_LIST_EXPORT_EXCEL";
  if (format === "PDF") return "DESIGN_SCOPE_MILESTONE_LIST_EXPORT_PDF";
  return "DESIGN_SCOPE_MILESTONE_LIST_EXPORT_CSV";
}

function safeFileToken(value: string | undefined, fallback: string): string {
  return (
    (value || fallback)
      .replace(/[\\/:*?"<>|]/g, " ")
      .replace(/\s+/g, " ")
      .trim() || fallback
  );
}

/** Base name without extension — used for CSV/Excel filenames and PDF audit. */
export function designScopeLinkedScopeFileBaseName(input: {
  designPackageTitle?: string;
  milestoneName?: string;
  label?: string;
  projectName?: string;
}): string {
  const packagePart = safeFileToken(
    input.designPackageTitle || input.label,
    "Design_Package"
  );
  const milestonePart = safeFileToken(input.milestoneName, "Milestone");
  const projectPart = safeFileToken(input.projectName, "Project");
  return `Design_Scope_${packagePart}_${milestonePart}_${projectPart}`;
}
